import { withResolvePaths } from "../../../withResolvePaths";
import { withFocusManagement } from "../../../Services/FocusManagement/withFocusManagement";

import { StickyTableBodyRow } from "./StickyTableBodyRow";

export const StickyTableBodyRowContainer = withResolvePaths(withFocusManagement(StickyTableBodyRow));
